"use client"

import "aos/dist/aos.css"
import Title from "@/components/Title/Title"

const ourTeam = [
  // {
  //   name: "Saleh Nasser Al Arq",
  //   position: "CEO & General Manager",
  //   image: "saleh.png",
  // },
  {
    name: "Luca Lombardozzi",
    position: "CEO & Partner",
    image: "luca.png",
  },
  {
    name: "Luca Pavan",
    position: "COO - Chief Operating Officer",
    image: "pavan.png",
  },
  {
    name: "Isaac Farooq",
    position: "Technical Director",
    image: "isaac.png",
  },
  {
    name: "Pietro Domma",
    position: "Project Manager",
    image: "pietro.png",
  },
  {
    name: "Marco Lombardozzi",
    position: "Cyber Risk and Resillience Expert",
    image: "marco.jpg",
  },
  {
    name: "Abdulaziz Almarfadi",
    position: "Cyber Quality Assurance Manager",
    image: "abdul.png",
  },
]

function Team() {
  return (
    <article id="team" className="flex flex-col w-full mb-16 lg:mb-40">
      <div
        className="flex flex-col py-16 ps-6 xl:ps-16 3xl:ps-24 bg-[--color-light] w-full"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="400"
      >
        <div className="flex flex-row justify-between w-full ">
          <div className="flex">
            <Title
              type="h2"
              className="uppercase text-[24px] xl:text-[60px]"
              orange="team"
              title=""
            />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1  lg:grid-cols-2 xl:grid-cols-3 px-5 pt-24 xl:px-16 2xl:px-24 ">
        {ourTeam.map((member, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 200}
            className="member flex flex-row justify-center items-center text-left gap-8 w-full p-10 2xl:p-18"
            style={{ width: "100%" }}
          >
            <img
              src={`/team/${member.image}`}
              alt={member.name}
              width={280}
              height={280}
              loading="lazy"
              decoding="async"
              className="object-cover w-[140px] 2xl:max-w-[280px] rounded-full"
            />
            <div className="flex flex-col w-full">
              <h4 className="text-[18px] lg:text-[24px] font-oswald text-orange uppercase font-bold">
                {member.name}
              </h4>
              <span className="text-[16px] lg:text-[18px]">
                {member.position}
              </span>
            </div>
          </div>
        ))}
      </div>
    </article>
  )
}

export default Team
